// noinspection JSCheckFunctionSignatures
export default class Recruit
{
	static expand_line(link, type, line)
	{
		const arrow = $(link).find('._line_arrow')
		arrow.toggleClass('_arrow_rotate')

		const area = line ? `#line_${type}_${line}` : `#type_${type}`

		const station = $(area)
		station.toggleClass(line ? '_station_open' : '_line_open')
	}

	static _max_station = 50

	static check_line(checkbox, type, line)
	{
		const current = $(checkbox.form).find('input[name="line"]:checked').length
		const added = $(`#line_${type}_${line} input`)

		if(checkbox.checked && current + added.length > this._max_station)
		{
			checkbox.checked = !checkbox.checked
			alert(`選択した駅が${this._max_station}を超えています`)
		}
		else added.prop('checked', checkbox.checked)
	}

	static check_station(checkbox)
	{
		const current = $(checkbox.form).find('input[name="line"]:checked').length

		if(checkbox.checked && current > this._max_station)
		{
			checkbox.checked = !checkbox.checked
			alert(`選択した駅が${this._max_station}を超えています`)
		}
	}

	static apply_station(form)
	{
		let list = []

		$(form).find('input[name="line"]:checked').each((index, element) =>
		{
			list.push($(element).val())
		})

		if(list.length === 0)
		{
			alert('駅を選択してください')
			return
		}

		const area = parent.document.querySelector('#station')
		area.innerHTML = '<ul>'

		for(const station of list)
		{
			area.innerHTML += `<li><input type="hidden" name="station[]" value="${station}">${station.replace(/_/g, ' ')}駅<br>`
		}

		area.innerHTML += '</ul>'

		const modal = parent.$('.remodal').remodal()
		modal.close()
	}
}
